// hooks/use-permission.ts
import { PermissionAction, PermissionResource } from '@/constants/user'
import { usePermissionStore } from '@/stores/permission.store'


type AccessOptions = {
  action: PermissionAction | PermissionAction[]
}

export function usePermission(resource: PermissionResource, options: AccessOptions) {
  const permissions = usePermissionStore((s) => s.permissions)
  const actions = Array.isArray(options.action) ? options.action : [options.action]

  return actions.every((action) => permissions.includes(`${resource}.${action}`))
}
